import React, { useState, useEffect } from "react";
import TypingAnimationComponent from "../common/TypingAnimationComponent";

import banner1 from "../../assests/banner_1.JPG";
import banner2 from "../../assests/banner_2.JPG";
import banner3 from "../../assests/banner_3.JPG";
import banner4 from "../../assests/banner_4.JPG";
import banner5 from "../../assests/banner_5.JPG";
import banner6 from "../../assests/banner_6.JPG";

export default function HeroSectionComponent() {
  const images = [banner1, banner2, banner3, banner4, banner5, banner6];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);

      setTimeout(() => {
        setCurrentImageIndex((prevIndex) =>
          prevIndex === images.length - 1 ? 0 : prevIndex + 1,
        );
        setFade(true);
      }, 500);
    }, 10000);

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <section
      className="position-relative d-flex align-items-center justify-content-center text-white overflow-hidden"
      style={{ minHeight: "90vh" }}
    >
      {/* Smooth Animated Background */}
      <div
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{
          backgroundImage: `url(${images[currentImageIndex]})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          animation: "zoomEffect 22s ease-in-out infinite alternate",
          opacity: fade ? 1 : 0,
          transition: "opacity 0.6s ease-in-out",
          zIndex: 1,
          filter: "brightness(0.6)",
        }}
      ></div>

      {/* Light Gradient Overlay for Futuristic Glow */}
      <div
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{
          background:
            "radial-gradient(circle at 50% 30%, rgba(255,255,255,0.25), rgba(0,0,0,0.8))",
          zIndex: 2,
          mixBlendMode: "overlay",
        }}
      ></div>

      {/* Soft Dark Overlay */}
      <div
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.45)",
          zIndex: 3,
        }}
      ></div>

      {/* HERO CONTENT */}
      <div
        className="container position-relative"
        style={{ zIndex: 5, maxWidth: "900px" }}
      >
        <div className="text-center" data-aos="fade-up">
          <div className="p-4 p-md-5 mx-auto">
            <h1 className="fw-semibold display-4 mb-3 text-white-50">
              Old Boys' Association of Vidyaloka College
            </h1>

            <h3 className="fw-semibold mb-4 text-white-50">
              Established in 1953
            </h3>

            <p className="lead text-white-50 fs-4">
              <TypingAnimationComponent
                texts={[
                  "Connecting past, present, and future generations under one flag",
                ]}
              />
            </p>
          </div>
        </div>
      </div>

      {/* Decorative Futuristic Glow Lines */}
      <div
        className="position-absolute"
        style={{
          top: "10%",
          left: "0",
          width: "100%",
          height: "2px",
          background:
            "linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent)",
          opacity: 0.4,
          zIndex: 4,
        }}
      ></div>
      <div
        className="position-absolute"
        style={{
          bottom: "10%",
          left: "0",
          width: "100%",
          height: "2px",
          background:
            "linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent)",
          opacity: 0.4,
          zIndex: 4,
        }}
      ></div>

      {/* Zoom Animation Keyframes */}
      <style jsx>{`
        @keyframes zoomEffect {
          0% {
            transform: scale(1);
          }
          100% {
            transform: scale(1.13);
          }
        }
      `}</style>
    </section>
  );
}
